export class ConstantsHelper {
  // public static readonly REGEX = {
  //   NUMBER_INPUT: "^[0-9]*$",
  //   PASSWORD: ""
  // };

  public static readonly MAX_SKU_RESET_PERIOD = [
    { value: "None", viewValue: "None" },
    { value: "Daily", viewValue: "Daily" },
    { value: "Weekly", viewValue: "Weekly" },
    { value: "Monthly", viewValue: "Monthly" },
    { value: "Yearly", viewValue: "Yearly" }
  ];

  public static readonly ROUDING_OPTIONS = [
    { value: "ROUND_OFF", viewValue: "Round Off" },
    { value: "ROUND_UP", viewValue: "Round Up" },
    { value: "ROUND_DOWN", viewValue: "Round Down" }
  ];

  public static readonly DISCOUNT_TYPES = [
    { value: "1", viewValue: "Discount Amount" },
    { value: "2", viewValue: "Discount Rate" }
  ];
  public static readonly GENERATION_TYPE = {
    pre_generated: "PG",
    on_demand: "OD"
  };

  public static readonly RESET_DAY_OPTIONS = [
    { value: "None", viewValue: "None" },
    { value: "FIRST_DAY", viewValue: "First Day" },
    { value: "TRANSACTION_DAY", viewValue: "First Purchase" }
  ]

  public static readonly APPLY_DISCOUNT_TO_OPTIONS = [
    { value: "NTH_PCS", viewValue: "All Pieces" },
    { value: "EACH_PCS", viewValue: "Single Piece" }
  ]

  public static readonly PERMISSION_STRINGS = {
    add: "-ADD",
    update: "-UPD",
    view: "-VIEW",
    download: "-DL",
    upload: "-UL",
  }

  public static readonly FILE_STATUS = {
    DONE: "Done",
    DONE_WITH_ERRORS: "Done with errors",
    FAILED: "Failed"
  }
  
  public static readonly CONSENT_VISIBILITY = {
    BOTH: "BOTH",
    REGISTRATION_ONLY: "REGISTRATION_ONLY",
    EDIT_ONLY: "EDIT_ONLY",
    HIDDEN: "HIDDEN"
  }

  public static readonly TIER_BASE_DISCOUNT_OPTIONS = [
    { value: 'None', viewValue: "None" },
    { value: 'period', viewValue: 'Period Tier' },
    { value: 'transaction_count', viewValue: 'Transaction Count Tier' }
  ]

  public static readonly PERIOD_TIER_OPTIONS = [
    { value: "Daily", viewValue: "Daily" },
    { value: "Weekly", viewValue: "Weekly" },
    { value: "Monthly", viewValue: "Monthly" },
    { value: "Yearly", viewValue: "Yearly" }
  ];

  public static readonly REPORT_STATUS = {
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    IN_QUEUE: "IN_QUEUE",
    GENERATING: "GENERATING"
  };
  
}
